var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQ5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 408.9,
    height: 127.455,
    viewBox: "0 0 408.9 127.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_300",
    "data-name": "Rettangolo 300",
    width: 77.3,
    height: 80.504,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_306",
    "data-name": "Rettangolo 306",
    width: 20.372,
    height: 32.321,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_301",
    "data-name": "Rettangolo 301",
    width: 8.738,
    height: 21.481,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_302",
    "data-name": "Rettangolo 302",
    width: 12.862,
    height: 5.867,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_303",
    "data-name": "Rettangolo 303",
    width: 14.521,
    height: 15.111,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_304",
    "data-name": "Rettangolo 304",
    width: 11.649,
    height: 27.252,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3652",
    "data-name": "Tracciato 3652",
    d: "M53.129,22.787a.7.7,0,0,0-.287.634,2.162,2.162,0,0,0,.983,1.7.7.7,0,0,0,.7.07L64.883,19.1l8.983-5.284a.7.7,0,0,1-.7-.068,2.17,2.17,0,0,1-.983-1.7.692.692,0,0,1,.287-.633Z",
    transform: "translate(-52.842 -11.414)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_330",
    "data-name": "Rettangolo 330",
    width: 124.502,
    height: 95,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_315",
    "data-name": "Rettangolo 315",
    width: 11.82,
    height: 14.071,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_309",
    "data-name": "Rettangolo 309",
    width: 4.874,
    height: 2.177,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_310",
    "data-name": "Rettangolo 310",
    width: 1.879,
    height: 5.239,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_311",
    "data-name": "Rettangolo 311",
    width: 2.885,
    height: 5.43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_312",
    "data-name": "Rettangolo 312",
    width: 4.885,
    height: 3.387,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_313",
    "data-name": "Rettangolo 313",
    width: 10.606,
    height: 13.345,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_322",
    "data-name": "Rettangolo 322",
    width: 6.929,
    height: 8.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_316",
    "data-name": "Rettangolo 316",
    width: 2.878,
    height: 1.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_317",
    "data-name": "Rettangolo 317",
    width: 1.058,
    height: 3.097,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_318",
    "data-name": "Rettangolo 318",
    width: 1.651,
    height: 3.225,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_319",
    "data-name": "Rettangolo 319",
    width: 2.867,
    height: 2.044,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_320",
    "data-name": "Rettangolo 320",
    width: 6.199,
    height: 7.96,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_329",
    "data-name": "Rettangolo 329",
    width: 7.008,
    height: 8.343,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_323",
    "data-name": "Rettangolo 323",
    width: 2.89,
    height: 1.291,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_324",
    "data-name": "Rettangolo 324",
    width: 1.114,
    height: 3.106,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_325",
    "data-name": "Rettangolo 325",
    width: 1.711,
    height: 3.22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_326",
    "data-name": "Rettangolo 326",
    width: 2.897,
    height: 2.008,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_327",
    "data-name": "Rettangolo 327",
    width: 6.288,
    height: 7.913,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Domanda_3.5",
    "data-name": "Domanda 3.5",
    transform: "translate(14.213 -94)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_703",
    "data-name": "Raggruppa 703",
    transform: "translate(246.796 251.995) rotate(179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_723",
    "data-name": "Raggruppa 723",
    transform: "translate(-47.792 16.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3778",
    "data-name": "Tracciato 3778",
    d: "M11.055,70.787C-7.6,63.706,2.288,46.6,5.481,31.059c.882-4.3,8.185-8.432,21.18-11.332,28.361-6.321,60.375-2.1,88.142,1.373,22.026,2.754,49.858,5.047,70.19,1.6,14.839-2.515,19.951-7.183,27.314-11.214,9.484-5.19,26.144-10.092,48.9-11.238,28.589-1.44,56.913,3.6,71.46,9.8s19.179,13.436,27.584,20.277c12.008,9.783,32.027,18.934,41.8,28.864s7.414,21.43-20.614,29c-22.072,5.958-56.758,8.435-89.57,8.007s-64.152-3.443-93.557-7.034c-23.515-2.87-47.4-6.213-73.671-6.365-17.454-.1-52.934.142-68.715-1.688-17.36-2.013-34.463-6.368-44.87-10.32",
    transform: "translate(-100.734 18.414)",
    fill: "#3f3d94"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_581",
    "data-name": "Raggruppa 581",
    transform: "translate(60.7 124)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_556",
    "data-name": "Raggruppa 556",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_555",
    "data-name": "Raggruppa 555",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3621",
    "data-name": "Tracciato 3621",
    d: "M40.06,42.353l1.63-.947a2.345,2.345,0,0,1-.45.339l-1.63.948a2.361,2.361,0,0,0,.45-.34",
    transform: "translate(0.969 1.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3622",
    "data-name": "Tracciato 3622",
    d: "M47.073,19.763l1.629-.947a2.4,2.4,0,0,1,2.143-.015l-1.629.947a2.4,2.4,0,0,0-2.143.015",
    transform: "translate(1.152 0.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3623",
    "data-name": "Tracciato 3623",
    d: "M49.164,19.742l1.63-.947a4.5,4.5,0,0,1,.529.26L49.693,20a4.281,4.281,0,0,0-.529-.261",
    transform: "translate(1.203 0.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3624",
    "data-name": "Tracciato 3624",
    d: "M49.681,20l1.629-.947a6.893,6.893,0,0,1,2.141,2.057,8.084,8.084,0,0,1,1.362,3.247l-1.629.947a8.1,8.1,0,0,0-1.362-3.247A6.9,6.9,0,0,0,49.681,20",
    transform: "translate(1.215 0.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3625",
    "data-name": "Tracciato 3625",
    d: "M53.419,25.174l1.63-.947a3.571,3.571,0,0,1-.634,3.046C52.5,29.287,42.22,41.2,41.679,41.826l-1.629.947c.541-.627,10.817-12.539,12.735-14.553a3.567,3.567,0,0,0,.634-3.047",
    transform: "translate(0.98 0.592)",
    fill: "#ababab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3626",
    "data-name": "Tracciato 3626",
    d: "M50.126,19.986a6.9,6.9,0,0,1,2.141,2.057c1.61,2.317,1.891,5.071.727,6.293-1.918,2.014-12.2,13.926-12.736,14.553-.958.921-2.424.852-3.907,0a9.373,9.373,0,0,1-2.9-2.784c-2.146-3.087-2.581-6.843-.969-8.391.63-.5,12.617-9.953,14.679-11.758a2.494,2.494,0,0,1,2.966.035",
    transform: "translate(0.771 0.476)",
    fill: "#ababab"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3627",
    "data-name": "Tracciato 3627",
    d: "M.011,59.615l33.6,19.528-.011-4L0,55.612Z",
    transform: "translate(0 1.361)",
    fill: "#ababab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3628",
    "data-name": "Tracciato 3628",
    d: "M32.8,75.141l.012,4L66.637,59.615l-.012-4Z",
    transform: "translate(0.803 1.361)",
    fill: "#dcdcdc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3629",
    "data-name": "Tracciato 3629",
    d: "M0,56.079,33.6,75.607,67.428,56.079l-33.6-19.528Z",
    transform: "translate(0 0.894)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_576",
    "data-name": "Raggruppa 576",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_575",
    "data-name": "Raggruppa 575",
    clipPath: "url(#clip-path)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3630",
    "data-name": "Tracciato 3630",
    d: "M17.338,59.6A14.79,14.79,0,0,0,20,61.548c5.141,2.988,12.522,3.9,19.045,2.73a24.26,24.26,0,0,0,7.819-2.73c3.745-2.163,5.616-5,5.608-7.835l.006,2.131c.008,2.835-1.862,5.672-5.608,7.835a24.284,24.284,0,0,1-7.819,2.73c-6.523,1.168-13.9.257-19.046-2.73a14.9,14.9,0,0,1-2.665-1.943,7.977,7.977,0,0,1-2.854-5.783l-.006-2.131A7.975,7.975,0,0,0,17.338,59.6",
    transform: "translate(0.354 1.314)",
    fill: "#d83736"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3631",
    "data-name": "Tracciato 3631",
    d: "M20.09,46.249c-7.443,4.3-7.482,11.264-.087,15.562s19.421,4.3,26.864,0,7.482-11.263.088-15.56-19.423-4.3-26.865,0",
    transform: "translate(0.354 1.052)",
    fill: "#fe534f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_574",
    "data-name": "Raggruppa 574",
    transform: "translate(23.534 30.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_573",
    "data-name": "Raggruppa 573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_572",
    "data-name": "Raggruppa 572",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_571",
    "data-name": "Raggruppa 571",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_570",
    "data-name": "Raggruppa 570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_569",
    "data-name": "Raggruppa 569",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_559",
    "data-name": "Raggruppa 559",
    transform: "translate(11.633 10.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_558",
    "data-name": "Raggruppa 558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_557",
    "data-name": "Raggruppa 557",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3632",
    "data-name": "Tracciato 3632",
    d: "M34.327,62.292l8.723-5.069.015-16.412L34.343,45.88Z",
    transform: "translate(-34.327 -40.811)",
    fill: "#d4d4d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_562",
    "data-name": "Raggruppa 562",
    transform: "translate(1.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_561",
    "data-name": "Raggruppa 561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_560",
    "data-name": "Raggruppa 560",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3633",
    "data-name": "Tracciato 3633",
    d: "M33.366,30.622l-8.723,5.069c1.058-.615,2.522-.528,4.139.406l8.723-5.07c-1.617-.932-3.082-1.019-4.139-.4",
    transform: "translate(-24.643 -30.23)",
    fill: "#dcdcdc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_565",
    "data-name": "Raggruppa 565",
    transform: "translate(5.851 0.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_564",
    "data-name": "Raggruppa 564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_563",
    "data-name": "Raggruppa 563",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3634",
    "data-name": "Tracciato 3634",
    d: "M34.48,46.12,43.2,41.051a12.781,12.781,0,0,0-5.8-10.043l-8.722,5.07a12.779,12.779,0,0,1,5.8,10.042",
    transform: "translate(-28.683 -31.008)",
    fill: "#d4d4d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_568",
    "data-name": "Raggruppa 568",
    transform: "translate(0 5.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_567",
    "data-name": "Raggruppa 567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_566",
    "data-name": "Raggruppa 566",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3635",
    "data-name": "Tracciato 3635",
    d: "M28.823,35.976C25.61,34.122,23,35.61,22.987,39.3l-.015,16.412L34.6,62.43l.015-16.412a12.779,12.779,0,0,0-5.8-10.042",
    transform: "translate(-22.972 -35.178)",
    fill: "#f2f2f2"
  }))))))))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3636",
    "data-name": "Tracciato 3636",
    d: "M31.925,47.052l1.629-.947a2.349,2.349,0,0,1-.449.339l-1.63.948a2.361,2.361,0,0,0,.45-.34",
    transform: "translate(0.77 1.127)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3637",
    "data-name": "Tracciato 3637",
    d: "M38.938,24.461l1.629-.947A2.4,2.4,0,0,1,42.71,23.5l-1.629.947a2.4,2.4,0,0,0-2.143.015",
    transform: "translate(0.953 0.568)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3638",
    "data-name": "Tracciato 3638",
    d: "M41.029,24.441l1.629-.947a4.432,4.432,0,0,1,.53.26l-1.63.948a4.28,4.28,0,0,0-.529-.261",
    transform: "translate(1.004 0.574)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3639",
    "data-name": "Tracciato 3639",
    d: "M41.546,24.695l1.629-.947a6.893,6.893,0,0,1,2.141,2.057,8.069,8.069,0,0,1,1.362,3.247L45.049,30a8.1,8.1,0,0,0-1.362-3.247,6.9,6.9,0,0,0-2.141-2.057",
    transform: "translate(1.016 0.581)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3640",
    "data-name": "Tracciato 3640",
    d: "M45.284,29.873l1.629-.947a3.567,3.567,0,0,1-.634,3.047C44.362,33.986,34.085,45.9,33.544,46.525l-1.63.947c.541-.627,10.818-12.538,12.736-14.553a3.571,3.571,0,0,0,.634-3.047",
    transform: "translate(0.781 0.707)",
    fill: "#c9c9c9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3641",
    "data-name": "Tracciato 3641",
    d: "M41.991,24.684a6.9,6.9,0,0,1,2.141,2.057c1.61,2.317,1.891,5.071.727,6.293-1.918,2.014-12.2,13.926-12.736,14.553-.958.921-2.424.852-3.907,0a9.384,9.384,0,0,1-2.9-2.784c-2.146-3.086-2.581-6.843-.969-8.391.63-.5,12.617-9.953,14.679-11.758a2.494,2.494,0,0,1,2.966.035",
    transform: "translate(0.572 0.591)",
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3642",
    "data-name": "Tracciato 3642",
    d: "M36.548,20.334c.043-.9.137-2.105.236-3,.05-.464.17-1.076.26-1.534a26.28,26.28,0,0,1,1.23-4.234c.389-.934.939-2.169,1.4-3.069.348-.675.891-1.534,1.3-2.176.385-.612.963-1.385,1.412-1.952s1.087-1.293,1.578-1.825c-1.854,1.968-2.971,5.007-3.043,8.952-2.854,2.722-4.317,5.791-4.372,8.841",
    transform: "translate(0.894 0.062)",
    fill: "#f23e3a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3643",
    "data-name": "Tracciato 3643",
    d: "M40.815,11.555C41.007,1.006,48.67-3.06,57.931,2.473S74.545,21.043,74.352,31.591,66.5,46.206,57.236,40.673,40.624,22.1,40.815,11.555",
    transform: "translate(0.998 0)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3644",
    "data-name": "Tracciato 3644",
    d: "M73.118,31.54C73,37.939,69.9,41.912,65.025,41.912a12.766,12.766,0,0,1-5.194-1.25,19.155,19.155,0,0,1-2-1.052c-8.918-5.326-16.02-17.915-15.834-28.061.116-6.4,3.217-10.371,8.093-10.371a14.435,14.435,0,0,1,7.2,2.3,30.423,30.423,0,0,1,8.31,7.644c4.619,6.026,7.645,13.749,7.524,20.418",
    transform: "translate(1.027 0.028)",
    fill: "#d4d4d4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3645",
    "data-name": "Tracciato 3645",
    d: "M72.852,31.333c-.117,6.4-3.218,10.372-8.093,10.372a12.766,12.766,0,0,1-5.194-1.25c-3.779-3-6.789-12.662-6.668-19.331.116-6.395,6.7-14.674,12.432-10.209,4.619,6.026,7.645,13.749,7.524,20.418",
    transform: "translate(1.294 0.236)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3646",
    "data-name": "Tracciato 3646",
    d: "M47.422,39.778c-.686-.42-1.585-1.011-2.223-1.5A24.933,24.933,0,0,1,43.03,36.4a21.182,21.182,0,0,1-2.085-2.37,22.664,22.664,0,0,1-1.578-2.4,21.44,21.44,0,0,1-2.2-5.643,23.011,23.011,0,0,1-.466-2.663c-.042-.4-.1-.929-.116-1.329-.027-.561-.042-1.311-.037-1.874C36.6,17.07,38.066,14,40.92,11.279,40.728,21.828,48.08,34.864,57.342,40.4c3.733,2.23,7.206,2.9,10.036,2.216-.524.11-1.216.285-1.746.365-.936.141-2.19.329-3.138.371a26.719,26.719,0,0,1-5.752-.255c-.729-.1-1.694-.3-2.409-.48-.792-.2-1.835-.519-2.6-.793a25.162,25.162,0,0,1-4.307-2.043",
    transform: "translate(0.894 0.275)",
    fill: "#f23e3a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3647",
    "data-name": "Tracciato 3647",
    d: "M37.9,25.662h0Z",
    transform: "translate(0.927 0.627)",
    fill: "#082c44"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3648",
    "data-name": "Tracciato 3648",
    d: "M64.883,19.1l8.983-5.283a.7.7,0,0,1-.7-.07,2.165,2.165,0,0,1-.983-1.7.688.688,0,0,1,.288-.633L53.129,22.788a.691.691,0,0,0-.288.633,2.17,2.17,0,0,0,.985,1.7.7.7,0,0,0,.7.069Z",
    transform: "translate(1.293 0.279)",
    fill: "#082c44"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_578",
    "data-name": "Raggruppa 578",
    transform: "translate(54.135 11.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_577",
    "data-name": "Raggruppa 577",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3649",
    "data-name": "Tracciato 3649",
    d: "M72.461,11.415,53.124,22.788a.488.488,0,0,0-.076.054L72.386,11.469a.436.436,0,0,1,.075-.054",
    transform: "translate(-52.837 -11.414)",
    fill: "#082c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3650",
    "data-name": "Tracciato 3650",
    d: "M72.391,11.468,53.054,22.841a.75.75,0,0,0-.213.58,1.971,1.971,0,0,0,.262.923L72.44,12.971a1.986,1.986,0,0,1-.262-.924.753.753,0,0,1,.213-.579",
    transform: "translate(-52.842 -11.413)",
    fill: "#082c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3651",
    "data-name": "Tracciato 3651",
    d: "M72.434,12.935,53.1,24.309a2.041,2.041,0,0,0,.721.778.7.7,0,0,0,.7.07L73.859,13.782a.7.7,0,0,1-.7-.069,2.038,2.038,0,0,1-.722-.779",
    transform: "translate(-52.836 -11.377)",
    fill: "#082c44"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_580",
    "data-name": "Raggruppa 580",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_579",
    "data-name": "Raggruppa 579",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3653",
    "data-name": "Tracciato 3653",
    d: "M72.707,11.485c-.545-.315-.989-.062-.991.564a2.17,2.17,0,0,0,.985,1.7c.545.315.989.062.991-.562a2.17,2.17,0,0,0-.985-1.7",
    transform: "translate(1.755 0.277)",
    fill: "#0b1b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3654",
    "data-name": "Tracciato 3654",
    d: "M75.635,13.442a3.794,3.794,0,1,0-3.794,3.794,3.794,3.794,0,0,0,3.794-3.794",
    transform: "translate(1.665 0.236)",
    fill: "#fe534f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3655",
    "data-name": "Tracciato 3655",
    d: "M73.951,10.3a3.755,3.755,0,0,1,.278,3.058c-.4,1.329-2.935,3.042-4.76,3.037A3.785,3.785,0,1,0,73.951,10.3",
    transform: "translate(1.7 0.251)",
    fill: "#f23e3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3656",
    "data-name": "Tracciato 3656",
    d: "M72.19,11.989a1.43,1.43,0,1,0-1.43,1.43,1.43,1.43,0,0,0,1.43-1.43",
    transform: "translate(1.696 0.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3657",
    "data-name": "Tracciato 3657",
    d: "M25.473,39.756c0-1.779,1.249-2.5,2.791-1.61a6.166,6.166,0,0,1,2.79,4.832c0,1.779-1.249,2.5-2.79,1.61a6.164,6.164,0,0,1-2.791-4.832",
    transform: "translate(0.623 0.923)",
    fill: "#464746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3658",
    "data-name": "Tracciato 3658",
    d: "M29.5,44.442c.955,0,1.029-1.13,1.029-1.476a5.694,5.694,0,0,0-2.532-4.387A2.05,2.05,0,0,0,27,38.268c-.954,0-1.029,1.13-1.029,1.476a5.69,5.69,0,0,0,2.532,4.386A2.041,2.041,0,0,0,29.5,44.442Z",
    transform: "translate(0.636 0.936)",
    fill: "#2e2f2e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_646",
    "data-name": "Raggruppa 646",
    transform: "translate(16.423 109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_645",
    "data-name": "Raggruppa 645",
    transform: "translate(54 -15)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_602",
    "data-name": "Raggruppa 602",
    transform: "translate(71.071 77.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_601",
    "data-name": "Raggruppa 601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_600",
    "data-name": "Raggruppa 600",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_599",
    "data-name": "Raggruppa 599",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_598",
    "data-name": "Raggruppa 598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_597",
    "data-name": "Raggruppa 597",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_584",
    "data-name": "Raggruppa 584",
    transform: "translate(0 1.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_583",
    "data-name": "Raggruppa 583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_582",
    "data-name": "Raggruppa 582",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3659",
    "data-name": "Tracciato 3659",
    d: "M68.418,4.022,69.632,3.3,65.973,1.845l-1.214.726Z",
    transform: "translate(-64.759 -1.844)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_587",
    "data-name": "Raggruppa 587",
    transform: "translate(7.984 8.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_586",
    "data-name": "Raggruppa 586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_585",
    "data-name": "Raggruppa 585",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3660",
    "data-name": "Tracciato 3660",
    d: "M75.821,16.742l1.214-.726L76.371,11.5l-1.215.726Z",
    transform: "translate(-75.157 -11.503)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_590",
    "data-name": "Raggruppa 590",
    transform: "translate(5.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_589",
    "data-name": "Raggruppa 589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_588",
    "data-name": "Raggruppa 588",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3661",
    "data-name": "Tracciato 3661",
    d: "M73.285,5.43,74.5,4.7,72.828,0,71.614.726Z",
    transform: "translate(-71.614 0)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_593",
    "data-name": "Raggruppa 593",
    transform: "translate(6.934 4.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_592",
    "data-name": "Raggruppa 592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_591",
    "data-name": "Raggruppa 591",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3662",
    "data-name": "Tracciato 3662",
    d: "M77.461,9.513l1.214-.726L75,6.126l-1.214.726Z",
    transform: "translate(-73.79 -6.127)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_596",
    "data-name": "Raggruppa 596",
    transform: "translate(0 0.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_595",
    "data-name": "Raggruppa 595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_594",
    "data-name": "Raggruppa 594",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3663",
    "data-name": "Tracciato 3663",
    d: "M70.022.945l-1.6,2.867L64.759,2.361,67.442,6.8l-.59,3.809,3.262-.127,3.294,3.8-.665-4.513L75.364,8.31,71.693,5.65Z",
    transform: "translate(-64.759 -0.945)",
    fill: "#ffc400"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_623",
    "data-name": "Raggruppa 623",
    transform: "translate(3.845 9.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_622",
    "data-name": "Raggruppa 622",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_621",
    "data-name": "Raggruppa 621",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_620",
    "data-name": "Raggruppa 620",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_619",
    "data-name": "Raggruppa 619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_618",
    "data-name": "Raggruppa 618",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_605",
    "data-name": "Raggruppa 605",
    transform: "translate(4.051 0.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_604",
    "data-name": "Raggruppa 604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_603",
    "data-name": "Raggruppa 603",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3664",
    "data-name": "Tracciato 3664",
    d: "M47.015,50.143l-.73-.412,2.148-.914.73.413Z",
    transform: "translate(-46.284 -48.817)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_608",
    "data-name": "Raggruppa 608",
    transform: "translate(1.248 5.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_607",
    "data-name": "Raggruppa 607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_606",
    "data-name": "Raggruppa 606",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3665",
    "data-name": "Tracciato 3665",
    d: "M43.364,57.792l-.73-.412.327-2.685.731.412Z",
    transform: "translate(-42.634 -54.695)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_611",
    "data-name": "Raggruppa 611",
    transform: "translate(2.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_610",
    "data-name": "Raggruppa 610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_609",
    "data-name": "Raggruppa 609",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3666",
    "data-name": "Tracciato 3666",
    d: "M44.522,51.05l-.73-.412.921-2.813.73.413Z",
    transform: "translate(-43.791 -47.824)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_614",
    "data-name": "Raggruppa 614",
    transform: "translate(0 2.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_613",
    "data-name": "Raggruppa 613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_612",
    "data-name": "Raggruppa 612",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3667",
    "data-name": "Tracciato 3667",
    d: "M41.739,53.531l-.73-.412,2.137-1.632.73.413Z",
    transform: "translate(-41.008 -51.488)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_617",
    "data-name": "Raggruppa 617",
    transform: "translate(0.73 0.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_616",
    "data-name": "Raggruppa 616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_615",
    "data-name": "Raggruppa 615",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3668",
    "data-name": "Tracciato 3668",
    d: "M45.017,48.362l.993,1.676,2.148-.914L46.633,51.8l.406,2.249L45.1,54.018l-1.9,2.3.327-2.685-1.576-.831L44.1,51.174Z",
    transform: "translate(-41.959 -48.362)",
    fill: "#ffc400"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_644",
    "data-name": "Raggruppa 644",
    transform: "translate(67.567 9.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_643",
    "data-name": "Raggruppa 643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_642",
    "data-name": "Raggruppa 642",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_641",
    "data-name": "Raggruppa 641",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_640",
    "data-name": "Raggruppa 640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_639",
    "data-name": "Raggruppa 639",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_626",
    "data-name": "Raggruppa 626",
    transform: "translate(0 0.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_625",
    "data-name": "Raggruppa 625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_624",
    "data-name": "Raggruppa 624",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3669",
    "data-name": "Tracciato 3669",
    d: "M2.17,18.9l.72-.431L.72,17.61,0,18.04Z",
    transform: "translate(0 -17.61)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_629",
    "data-name": "Raggruppa 629",
    transform: "translate(4.734 5.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_628",
    "data-name": "Raggruppa 628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_627",
    "data-name": "Raggruppa 627",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3670",
    "data-name": "Tracciato 3670",
    d: "M6.56,26.443l.719-.431-.394-2.676-.719.431Z",
    transform: "translate(-6.166 -23.336)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_632",
    "data-name": "Raggruppa 632",
    transform: "translate(3.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_631",
    "data-name": "Raggruppa 631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_630",
    "data-name": "Raggruppa 630",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3671",
    "data-name": "Tracciato 3671",
    d: "M5.055,19.736l.72-.431-.991-2.789-.719.43Z",
    transform: "translate(-4.065 -16.516)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_635",
    "data-name": "Raggruppa 635",
    transform: "translate(4.112 2.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_634",
    "data-name": "Raggruppa 634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_633",
    "data-name": "Raggruppa 633",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3672",
    "data-name": "Tracciato 3672",
    d: "M7.532,22.157l.72-.431L6.075,20.149l-.72.43Z",
    transform: "translate(-5.355 -20.149)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_638",
    "data-name": "Raggruppa 638",
    transform: "translate(0 0.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_637",
    "data-name": "Raggruppa 637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_636",
    "data-name": "Raggruppa 636",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3673",
    "data-name": "Tracciato 3673",
    d: "M3.121,17.077l-.951,1.7L0,17.917,1.591,20.55l-.35,2.259,1.934-.075,1.953,2.255-.394-2.676,1.554-.87L4.111,19.866Z",
    transform: "translate(0 -17.077)",
    fill: "#ffc400"
  })))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ5);
export default __webpack_public_path__ + "static/media/q5.7e8d039878422da91aeacfd0b3ab8570.svg";
export { ForwardRef as ReactComponent };